import { CurrencyReducer } from './shared/state/reducers/currency.reducer';

export const reducers = {
  currencyList: CurrencyReducer,
};
